
webpack.register(
    'components/video-detail/video-feed/video-feed',
    function() {
        return require('components/video-detail/video-feed/video-feed');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/video-detail/video-feed/video-feed'/>\r\n\r\n{{#each categories}}\r\n    <div class=\"s-video-detail-feed\">\r\n        <video-feed\r\n            {playlist}=\"playlist\"\r\n            {(active-playlist)}=\"activePlaylist\"\r\n            {title}=\"text\"\r\n            {type}=\"value\"\r\n            {(dtm-video-location)}=\"dtmVideoLocation\"\r\n            {(dtm-track)}=\"dtmTrack\"\r\n            {(play-all)}=\"playAll\"\r\n        >\r\n        </video-feed>\r\n    </div>\r\n{{/each}}\r\n");